export class FbAdSet {
  id: string;
  name: string;

  constructor(id: string) {
    this.id = id;
  }
}
